import './BellJobHint.scss';
import { ReactElement, useRef } from 'react';
import { OnboardingHint } from '@srm/ui/shell/UserMenu';
import { IBellArrival } from '@services/backgroundJobs/flyToBell';
import { backgroundJobKind } from '@services/backgroundJobs/backgroundJobKinds';

export interface IBellJobHintProps {
    /** Задача, прилетевшая в колокольчик; `null` — подсказки нет. */
    arrival: IBellArrival | null;
    /** Клик по подсказке — открыть колокольчик. */
    onActivate: () => void;
    onClose: () => void;
    /** Колокольчик: элемент, принимающий ref. */
    children: ReactElement;
}

/** Подсказка у колокольчика после ухода задачи в фон: где следить за её ходом. Вид — онбординг-подсказки шапки. */
const BellJobHint = ({ arrival, onActivate, onClose, children }: IBellJobHintProps) => {
    // Подсказка уходит анимацией — с текстом задачи, которую показывала.
    const shown = useRef(arrival);
    if (arrival) shown.current = arrival;
    const current = arrival ?? shown.current;

    return (
        <OnboardingHint
            opened={!!arrival}
            position="bottom"
            arrowPosition="center"
            offset={10}
            title={current?.hint ?? ''}
            text={current?.title ?? ''}
            icon={
                <svg className="bell-job-hint__icon" width="20" height="20" viewBox="7 7 14 14" aria-hidden="true">
                    <path d={backgroundJobKind(current?.kind).iconPath} />
                </svg>
            }
            onActivate={onActivate}
            onClose={onClose}
        >
            {children}
        </OnboardingHint>
    );
};

export default BellJobHint;
